module.exports = __webpack_public_path__ + "img/intelligentService-2.87a8a2b6.png";